import type { ApolloError } from '@apollo/client/errors'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('apollo:error', (error: ApolloError): void => {
    // Error handling here
    console.error(error)
  })
})
